import React, { Component } from 'react';


import { observable, computed } from 'mobx';
import { observer, inject } from 'mobx-react'
@inject("store")
@observer
class ClinicPractice extends Component {

	@observable error = false
	@observable errorText = "Please fill the name"

	componentDidMount() {
		this.props.store.step = 6
	}

	@computed get completed() {
		const { doctor } = this.props.store
		if (!( doctor.clinic.name)) { return false  }
		if (!( doctor.clinic.phone)) { return false  }
		if (!( doctor.clinic.address)) { return false  }
		return true
	}

	handleNext = () => {
		if (!this.completed) { this.error = true;return  }
		this.props.store.nextStep()
		this.props.history.push(`/listing/new/${this.props.store.step + 2}`)
	}

	handlePrev = () => {
		this.props.store.prevStep()
		this.props.history.push(`/listing/new/${this.props.store.step}`)
	}

	render() {
		const { doctor } = this.props.store
		return (
			<div>

				<h2>7. Clinics / Practices</h2>

			
				<h4>
					Primary Practice
				</h4>

				<div className="clinic">
					
					<div>
					<h5 className={`m-b-1 ${this.error && 'error'} ${this.error &&  doctor.clinic.name && 'complete'}`} >
						Clinic:
					</h5>	
					<input
						className={`input medium ${this.error && 'error'} ${this.error && doctor.clinic.name && 'complete'}`}
						type="text"
						placeholder="Medical Centre"
						value={doctor.clinic.name}
						onChange={e => doctor.clinic.name = e.target.value}
					/>
					</div>

					<div>					
						<h5 className="m-b-1">
						Other Name:
					</h5>	
					<input
						className={`input medium `}
						type="text"
						placeholder="Medical Centre"
						value={doctor.clinic.othername}
						onChange={e => doctor.clinic.othername = e.target.value}
					/>
					</div>
					
					<div>
					<h5 className={`m-b-1 ${this.error && 'error'} ${this.error &&  doctor.clinic.address && 'complete'}`}>
						Address:
					</h5>	
					<input
						type="text"
						placeholder="17 Street Suburb..."
						className={`input medium  ${this.error && 'error'} ${this.error && doctor.clinic.address && 'complete'}`}
						value={doctor.clinic.address}
						onChange={e => doctor.clinic.address = e.target.value} />
					</div>
					
					<div>
					<h5 className={`m-b-1 `}>
						Email:
					</h5>	
					<input
						type="email"
						placeholder="contact@medicalgroup.com.au"
						className={`input medium `}
						value={doctor.clinic.email}
						onChange={e => doctor.clinic.email = e.target.value} />
					</div>
					
					
					<div>
					<h5 className="m-b-1">
						Website:
					</h5>	
					<input
						type="text"
						placeholder="https://www..."
						className={`input medium m-b-1`}
						value={doctor.clinic.website}
						onChange={e => doctor.clinic.website = e.target.value} />
					</div>
					
					<div>
					<h5 className={`m-b-1 ${this.error && 'error'} ${this.error &&  doctor.clinic.phone && 'complete'}`}>
						Phone:
					</h5>	
					<input
						type="text"
						placeholder="08 9400..."
						className={`input medium  ${this.error && 'error'} ${this.error && doctor.clinic.phone && 'complete'}`}
						value={doctor.clinic.phone}
						onChange={e => doctor.clinic.phone = e.target.value} />
					</div>
					
					<div>
					<h5>
						Fax:
					</h5>	
					<input
						type="text"
						placeholder="08 9400..."
						className={`input medium m-b-1`}
						value={doctor.clinic.fax}
						onChange={e => doctor.clinic.fax = e.target.value} />
					</div>
				</div>
				
				<hr/>
				

				<h4>
					Secondary Clinics
				</h4>
				
				{doctor.clinics && doctor.clinics.map((theClinic, index) =>
					<div key={index} className="m-b-1">
						

						<div className="clinic">
								
								<div>
								<h5 >
									Clinic:
								</h5>	
								<input
									className={`input medium m-b-1`}
									type="text"
									placeholder="Medical Centre"
									value={theClinic.name}
									onChange={e => theClinic.name = e.target.value}
								/>
										</div>
										<div>
								<h5 >
									Other Name:
								</h5>	
								<input
									className={`input medium m-b-1`}
									type="text"
									placeholder="Medical Centre"
									value={theClinic.othername}
									onChange={e => theClinic.othername = e.target.value}
								/>
								</div>		
								
								<div>
								<h5>
									Address:
								</h5>	
								<input
									type="text"
									placeholder="17 Street Suburb..."
									className={`input medium m-b-1`}
									value={theClinic.address}
									onChange={e => theClinic.address = e.target.value} />
								</div>
								
								<div>
								<h5>
									Email:
								</h5>	
								<input
									type="email"
									placeholder="contact@medicalgroup.com.au"
									className={`input medium m-b-1`}
									value={theClinic.email}
									onChange={e => theClinic.email = e.target.value} />
								</div>
								
								
								<div>
								<h5>
									Website:
								</h5>	
								<input
									type="text"
									placeholder="https://www..."
									className={`input medium m-b-1`}
									value={theClinic.website}
									onChange={e => theClinic.website = e.target.value} />
								</div>
								
								<div>
								<h5>
									Phone:
								</h5>	
								<input
									type="text"
									placeholder="08 9400..."
									className={`input medium m-b-1`}
									value={theClinic.phone}
									onChange={e => theClinic.phone = e.target.value} />
								</div>
								
								<div>
								<h5>
									Fax:
								</h5>	
								<input
									type="text"
									placeholder="08 9400..."
									className={`input medium m-b-1`}
									value={theClinic.fax}
									onChange={e => theClinic.fax = e.target.value} />
								</div>
					
								</div>

					<div className="btn base sm" onClick={() => doctor.clinics.splice(index, 1)}>
						<i className="fa fa-fw fa-times" /> Remove
					</div>

					<hr/>	
					</div>)}
				
				<div>
					<div
						onClick={()=>doctor.clinics.push({ name: "", address: "", email: "", website: "", phone: "", fax: "", othername: ""})}
						className={`btn m-b-1`}><i className="fa fa-fw fa-plus"></i> Add Clinic</div>	
				</div>
				
				<hr/>

				<div className="m-t-1">
					<div
						onClick={this.handlePrev}	
						className={`btn base m-r-1`}><i className="fa fa-fw fa-arrow-left"></i> Previous</div>	
					<div
						onClick={this.handleNext}	
						className={`btn ${!this.completed && 'disabled'}`}><i className="fa fa-fw fa-arrow-right"></i> Next</div>
				</div>
				
			</div>
		);
	}
}

export default ClinicPractice;


// WEBPACK FOOTER //
// ./src/Containers/Listing/7.ClinicPractice.js